<template>
  <div class="guarantor-regional-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="(tableToolsPanel.indexOf('filter')>-1? '隐藏':'展开')+'筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="16">
                <FormItem label="保证人名称" prop="guarantorName" style="width:100%">
                  <Input v-model="filterModel.guarantorName" placeholder="输入保证人名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="地区" prop="cityId">
                  <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择"></Cascader>
                </FormItem>
              </i-col>
              <i-col span="16">
                <!-- <FormItem label="审核状态" prop="needAudit" style="width:100%">
                  <RadioGroup v-model="filterModel.needAudit" type="button">
                    <Radio :label="null">不限</Radio>
                    <Radio :label="true">待审核</Radio>
                    <Radio :label="false">审核通过</Radio>
                  </RadioGroup>
                </FormItem> -->
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <!-- <Button type="primary" to="/guarantors/new" icon="md-add">新增保证人</Button> -->
    </div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <!-- <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer /> -->
    <Modal
      v-model="regionalDetailModal"
      title="查看详情"
      @on-ok="regionalDetailModal=false;regionalDetail=null">
      <table class="detail-table" v-if="regionalDetail&&regionalDetail.guarantorName">
        <tr>
          <td class="title">保证人</td>
          <td>{{regionalDetail.guarantorName}}</td>
        </tr>
        <tr>
          <td class="title">审核状态</td>
          <td>
            <Tag :color="regionalDetail.needAudit?'primary':'success'">
              {{regionalDetail.needAudit?'待审核':'已审核'}}
            </Tag>
          </td>
        </tr>
        <tr>
          <td class="title">区域</td>
          <td>{{regionalDetail.cityName}}</td>
        </tr>
        <tr>
          <td class="title">最低费率(%/月)</td>
          <td>{{regionalDetail.minRate / 1000000||'--未设置--'}}</td>
        </tr>
        <tr>
          <td class="title">单笔限额(万元)</td>
          <td>{{regionalDetail.singleLimit / 100 / 10000||'--未设置--'}}</td>
        </tr>
        <tr>
          <td class="title">区域限额(万元)</td>
          <td>{{regionalDetail.regionalAllowance / 100 / 10000||'--未设置--'}}</td>
        </tr>
        <tr>
          <td class="title">担保种类</td>
          <td>{{getVarietyNames(regionalDetail.varieties)}}</td>
        </tr>
        <tr v-if="!regionalDetail.needAudit">
          <td class="title">审核人</td>
          <td>{{regionalDetail.auditorName}}</td>
        </tr>
      </table>
      <div slot="footer">
        <Button type="primary" v-if="regionalDetail&&regionalDetail.needAudit" @click="auditGuarantor(regionalDetail)">审核</Button>
        <Button @click="regionalDetailModal=false;regionalDetail=null">关闭</Button>
      </div>
    </Modal>
    <Modal
      v-model="auditModal"
      title="审核区域保证人">
      <Form ref="auditForm" :model="auditModel" v-if="auditModel&&auditModel.id"
        label-position="left"
        :label-width="120">
        <FormItem label="审核通过" prop="pass">
          <i-switch v-model="auditModel.pass" size="large">
            <span slot="open">通过</span>
            <span slot="close">拒绝</span>
          </i-switch>
        </FormItem>
        <FormItem label="拒绝原因"
          prop="comment"
          v-if="!auditModel.pass"
          :rules="!auditModel.pass?[{required:true,message:'请输入拒绝原因',trigger:'blur'}]:null">
          <Input v-model="auditModel.comment" placeholder="输入拒绝原因" />
        </FormItem>
        <FormItem label="最低费率(%·月)" prop="minRate" v-if="auditModel.pass">
          <InputNumber :min="0" :step="0.1" style="width: 200px"
              :formatter="value => `${value}%`"
              v-model="auditModel.minRate" placeholder="最低担保月费率(%)"></InputNumber>
        </FormItem>
        <FormItem label="单笔限额(万元)" prop="singleLimit" v-if="auditModel.pass">
          <InputNumber :min="0" style="width: 200px"
            v-model="auditModel.singleLimit" :step="1" placeholder="单笔限额(万元)"></InputNumber>
        </FormItem>
        <FormItem label="区域限额(万元)" prop="regionalAllowance" v-if="auditModel.pass">
          <InputNumber :min="0" style="width: 200px"
            v-model="auditModel.regionalAllowance" :step="1" placeholder="区域限额(万元)"></InputNumber>
        </FormItem>
        <FormItem label="担保种类" prop="varieties" v-if="auditModel.pass">
          <Select v-model="auditModel.varieties" filterable multiple>
            <Option v-for="(tp,idx) in guaTypes" :key="idx" :value="parseInt(tp.id)">{{tp.fullName}}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="auditSubmit">审核</Button>
        <Button @click="closeAuditRegionalModal">关闭</Button>
      </div>
    </Modal>
    <CertSelectModal
      :show="showCertSelectModal"
      :dataSigning="dataToSign"
      :mode="signMode"
      @cert-verified="certSigned"
      :callback="signCallback"
      @close-modal="showCertSelectModal=false" />
  </div>
</template>

<script>
import CertSelectModal from './../../components/CertSelectModal'
export default {
  name: 'guarantor-industrial-list',
  props: {
  },
  components: {
    CertSelectModal
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '保证人',
          key: 'guarantorName',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          },
          render: (h, params) => {
            return h('router-link', {
              props: {
                to: '/guarantors/detail/' + params.row.guarantorId
              }
            }, params.row.guarantorName)
          }
        },
        {
          title: '区域',
          key: 'cityName',
          width: 150,
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '审核状态',
          key: 'needAudit',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                // type: 'dot',
                color: params.row.needAudit ? 'primary' : 'success'
              }
            }, params.row.needAudit ? '待审核' : '审核通过')
          }
        },
        {
          title: '额度(万)',
          key: 'regionalAllowance',
          width: 120,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', {}, params.row.regionalAllowance / 100 / 10000)
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      this.regionalDetail = params.row
                      this.regionalDetailModal = true
                    }
                  }
                }, null)
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '审核',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      let userId = params.row.id
                      // this.$router.push({name: 'guarantor-edit', params: {guarantorId: params.row.id}})
                      this.auditModel.id = userId
                      this.auditModal = true
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let tId = params.row.id
                      this.deleteGuarantor(tId)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        cityId: null,
        cityName: null,
        guarantorId: null,
        guarantorName: null,
        varieties: null,
        needAudit: null
      },
      departments: [],
      curDepartmentId: null,
      regionalDetail: null,
      regionalDetailModal: false,
      auditModal: false,
      auditModel: {
        id: null,
        pass: true,
        singleLimit: null,
        regionalAllowance: null,
        varieties: null,
        cityId: null,
        comment: null
      },
      guaTypes: [],
      cities: [],
      industries: [],
      dataToSign: null,
      signMode: 'bin',
      signCallback: null,
      showCertSelectModal: false
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  mounted () {
    this.initGuaTypes()
    this.initData()
    this.initCitySelect()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Guarantor.listRegionalGuarantors(this.filterModel).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      // this.totalCount = res.totalCount
      // this.currentPageIndex = res.currentPage
      // this.pageSize = res.pageSize
      this.data = res
      this.$Spin.hide()
    },
    async deleteGuarantor (tId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该企业么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Guarantor.deleteGuarantor(tId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.id === tId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    },
    async certSigned (certSigned, callback) {
      console.log(certSigned)
      if (callback) {
        callback(certSigned)
      }
    },
    auditGuarantor () {
      this.auditModel = {
        id: null,
        pass: true,
        singleLimit: null,
        regionalAllowance: null,
        varieties: null,
        cityId: null,
        comment: null
      }
      Object.assign(this.auditModel, this.regionalDetail)
      if (this.auditModel.minRate) {
        this.auditModel.minRate = this.auditModel.minRate / 1000000
      }
      if (this.auditModel.singleLimit) {
        this.auditModel.singleLimit = this.auditModel.singleLimit / 10000 / 100
      }
      if (this.auditModel.regionalAllowance) {
        this.auditModel.regionalAllowance = this.auditModel.regionalAllowance / 10000 / 100
      }
      this.auditModel.pass = true
      this.auditModal = true
    },
    async initGuaTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Guarantee.getGuaranteeVarieties().then(res => {
          this.guaTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    async auditSubmit () {
      this.$refs.auditForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          if (this.auditModel.minRate && this.auditModel.minRate >= 0) {
            this.auditModel.minRate *= 1000000
          } else {
            this.auditModel.minRate = null
          }
          if (this.auditModel.singleLimit && this.auditModel.singleLimit >= 0) {
            this.auditModel.singleLimit *= 100 * 10000
          } else {
            this.auditModel.singleLimit = null
          }
          if (this.auditModel.regionalAllowance && this.auditModel.regionalAllowance >= 0) {
            this.auditModel.regionalAllowance *= 100 * 10000
          } else {
            this.auditModel.regionalAllowance = null
          }
          this.dataToSign = JSON.stringify(this.auditModel)
          this.signMode = 'normal'
          this.signCallback = this.doSubmitAuditRegional
          this.showCertSelectModal = true
        }
      })
    },
    async doSubmitAuditRegional (certSigned) {
      this.loading = true
      this.$Spin.show()
      await this.$Api.Guarantor.auditRegionalGuarantor(certSigned)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        let item = this.data.find(o => o.id === this.auditModel.id)
        Object.assign(item, this.auditModel)
        this.closeAuditRegionalModal()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
        this.closeAuditRegionalModal()
      })
    },
    closeAuditRegionalModal () {
      this.auditModel= {
        id: null,
        pass: true,
        singleLimit: null,
        regionalAllowance: null,
        varieties: null,
        cityId: null,
        comment: null
      }
      this.regionalDetail = null
      this.auditModal = false
      this.regionalDetailModal = false
    },
    getVarietyNames (input) {
      if (input instanceof Array) {
        let names = []
        input.forEach((i) => {
          let v = this.guaTypes.find(t => t.id === i)
          names.push(v.name)
        })
        return names.join(',')
      } else {
        let v = this.guaTypes.find(t => t.id === input)
        return v ? v.name : null
      }
    },
    initCitySelect () {
      this.$Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      this.$Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.filterModel.cityId = val[val.length - 1]
      } else {
        this.filterModel.cityId = val
      }
    }
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
